import moment from 'jalali-moment';
import endpoints from '../../config/endpoints';
import { Sidebar } from "../../layouts/Sidebar";
import { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { setLoading } from '../../services/reducers/homeSlice';
import restApi from '../../services/restApi';

import { useNavigate } from "react-router-dom";
import Swal from "sweetalert2";

const Specific = () => {
  const [data, setData] = useState([]);
  const [query, setQuery] = useState('');
  const dispatch = useDispatch();
  const navigate = useNavigate()
  
  const deleteItem = async (id: number) => {
    if(confirm('آیا مطمئن هستید؟')) {
      dispatch(setLoading(true));
      
      const res = await restApi(endpoints.specific.index + id, true).delete({});
      
      if(res.code == 204) {
        Swal.fire({
          title: 'موفق',
          text: 'مشخصه با موفقیت حذف شد',
          icon: 'success',
          confirmButtonText: 'متوجه شدم'
        })
      } else {
        Swal.fire({
          title: 'ناموفق',
          text: res?.data,
          icon: 'error',
          confirmButtonText: 'متوجه شدم'
        })
      }
      dispatch(setLoading(false));
    }
    fetchData()
  }
      const list = () => {
    const rows = [];
    
    data.filter((specific: any) => specific.title.toLowerCase().includes(query.toLowerCase())).map((specific: any, index) => {
      rows.push(
        <tr className="">
          <td className="svgContainer">
            <i className="eye"></i>
            <i className="trash clickable" onClick={() => deleteItem (specific.id)}></i>
            <a href={'/specific/edit/' + specific.id}><i className="edit clickable"></i></a>
          </td>
          <td className="">{moment(specific.createdAt).format('jYYYY/jMM/jDD HH:mm')}</td>
          <td className="">{specific.description}</td>
          <td className="">{specific.slug}</td>
          <td className="">{specific.title}</td>
          <td>{++index}</td>
        </tr>
      )
    })
    
    return rows;
  };
  
  const fetchData = async () => {
    dispatch(setLoading(true));
    
    const res = await restApi(endpoints.specific.index, true).get();
    
    if(res.code == 200){
      setData(res.data);
    }
    
    dispatch(setLoading(false));
  };
  
  useEffect(() => {
    fetchData();
  }, []);
  
  return(
    
    <>
      <body className="dashboardBody">
      <Sidebar />
      <main className="dashBoardMain">
        <h1 className="dashBoardTitle">لیست مشخصات فنی </h1>
        <div className="searchContainer">
          <a className="dashboardHeader clickable" href='/specific/add'>
            <p>افزودن مشخصه جدید</p>
            <i className="addPlus"></i>
          </a>
          <div className="dashboardseaechBox">
            <i className="dashMagnifierIcon"></i>
            <input className="dashSearchInput" placeholder="جستجو" onChange={(input: any) => setQuery(input.target.value)}></input>
          </div>
        </div>
        <table className="listTable">
          <thead>
          <tr className="firstTR">
            <th>عملیات</th>
            <th>تاریخ ساخت</th>
            <th>توضیحات</th>
            <th>اسلاگ</th>
            <th>عنوان</th>
            <th>ردیف</th>
          </tr>
          </thead>
          <tbody>
          {list()}
          </tbody>
        </table>
      </main>
      </body>
    </>
  )
}
export default Specific;